import React, { useState } from 'react';
import './ButtonEffectsSelector.css';

// Vorgefertigte Button-Effekte (Background + Text kombiniert)
const buttonEffects = [
    {
        id: 'none',
        name: 'None',
        preview: 'Button',
        styles: {}
    },
    {
        id: 'gradient-gold',
        name: 'Gold Gradient',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #FFD700 0%, #FFA500 50%, #FF8C00 100%)',
            backgroundSize: '300% 300%',
            animation: 'gradientShift 4s ease-in-out infinite',
            border: 'none'
        }
    },
    {
        id: 'gradient-blue',
        name: 'BonusClub Blue',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #667eea 0%, #764ba2 50%, #667eea 100%)',
            backgroundSize: '300% 300%',
            animation: 'gradientShift 5s ease-in-out infinite',
            border: 'none'
        }
    },
    {
        id: 'gradient-romantic',
        name: 'Romantic Red',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #FF6B9D 0%, #C44569 50%, #FF6B9D 100%)',
            backgroundSize: '300% 300%',
            animation: 'gradientShift 6s ease-in-out infinite',
            border: 'none'
        }
    },
    {
        id: 'glow-button',
        name: 'Soft Glow',
        preview: 'Button',
        styles: {
            boxShadow: '0 0 20px rgba(102, 126, 234, 0.4), 0 4px 12px rgba(0, 0, 0, 0.15)',
            animation: 'buttonGlow 3s ease-in-out infinite'
        }
    },
    {
        id: 'neon-button',
        name: 'Neon Glow',
        preview: 'Button',
        styles: {
            boxShadow: '0 0 15px currentColor, 0 0 30px rgba(102, 126, 234, 0.3), inset 0 0 15px rgba(255, 255, 255, 0.1)',
            animation: 'neonGlow 2s ease-in-out infinite'
        }
    },
    {
        id: 'spiritual-button',
        name: 'Spiritual Aura',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #E8D5FF 0%, #B794F6 50%, #E8D5FF 100%)',
            backgroundSize: '300% 300%',
            animation: 'gradientShift 8s ease-in-out infinite',
            border: 'none'
        }
    },
    {
        id: 'divine-button',
        name: 'Divine Light',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #FFF8DC 0%, #F0E68C 50%, #FFF8DC 100%)',
            backgroundSize: '300% 300%',
            animation: 'gradientShift 7s ease-in-out infinite',
            border: 'none',
            color: '#8B4513'
        }
    },
    {
        id: 'chakra-button',
        name: 'Chakra Energy',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #FF6B6B 0%, #4ECDC4 25%, #45B7D1 50%, #96CEB4 75%, #FF6B6B 100%)',
            backgroundSize: '400% 400%',
            animation: 'rainbowShift 12s ease-in-out infinite',
            border: 'none',
            color: '#FFFFFF',
            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.4)'
        }
    },
    {
        id: 'glass-button',
        name: 'Glass Effect',
        preview: 'Button',
        styles: {
            background: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            color: '#2D3748',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            textShadow: '0 1px 2px rgba(255, 255, 255, 0.5)'
        }
    },
    {
        id: 'fire-button',
        name: 'Fire Gradient',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #FF4757 0%, #FF6348 30%, #FFA502 60%, #FFD700 100%)',
            backgroundSize: '350% 350%',
            animation: 'fireShift 3s ease-in-out infinite',
            border: 'none',
            color: '#FFFFFF',
            textShadow: '1px 1px 3px rgba(0, 0, 0, 0.5)'
        }
    },
    {
        id: 'cosmic-button',
        name: 'Cosmic Dark',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #0F0C29 0%, #302B63 25%, #24243e 50%, #302B63 75%, #0F0C29 100%)',
            backgroundSize: '300% 300%',
            animation: 'gradientShift 10s ease-in-out infinite',
            border: '1px solid #667eea',
            color: '#FFFFFF',
            textShadow: '0 0 10px rgba(102, 126, 234, 0.8), 1px 1px 2px rgba(0, 0, 0, 0.5)',
            boxShadow: '0 0 20px rgba(102, 126, 234, 0.3)'
        }
    },
    {
        id: 'emerald-button',
        name: 'Emerald Flow',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #11998e 0%, #38ef7d 50%, #11998e 100%)',
            backgroundSize: '300% 300%',
            animation: 'gradientShift 6s ease-in-out infinite',
            border: 'none',
            color: '#FFFFFF',
            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.4)'
        }
    },
    {
        id: 'sunset-button',
        name: 'Sunset Vibes',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #FA8072 0%, #FF7F50 25%, #FFB347 50%, #FFA500 75%, #FA8072 100%)',
            backgroundSize: '350% 350%',
            animation: 'gradientShift 8s ease-in-out infinite',
            border: 'none',
            color: '#FFFFFF',
            textShadow: '1px 1px 3px rgba(0, 0, 0, 0.4)'
        }
    },
    {
        id: 'holographic-button',
        name: 'Holographic',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #ff9a9e 0%, #fecfef 20%, #fecfef 40%, #ff9a9e 60%, #a8edea 80%, #fed6e3 100%)',
            backgroundSize: '400% 400%',
            animation: 'rainbowShift 15s ease-in-out infinite',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            color: '#4A5568',
            textShadow: '0 1px 2px rgba(255, 255, 255, 0.8)',
            boxShadow: '0 4px 15px rgba(255, 154, 158, 0.3)'
        }
    },
    {
        id: 'matrix-button',
        name: 'Matrix Code',
        preview: 'Button',
        styles: {
            background: '#000000',
            color: '#00FF41',
            border: '1px solid #00FF41',
            textShadow: '0 0 10px #00FF41, 0 0 20px #00FF41, 0 0 30px #00FF41',
            boxShadow: '0 0 15px rgba(0, 255, 65, 0.5), inset 0 0 15px rgba(0, 255, 65, 0.1)',
            animation: 'matrixGlow 2.5s ease-in-out infinite'
        }
    },
    {
        id: 'soft-blush',
        name: 'Soft Blush',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #FFE4E6 0%, #FFC1CC 50%, #FFE4E6 100%)',
            backgroundSize: '300% 300%',
            animation: 'gradientShift 12s ease-in-out infinite',
            border: '1px solid rgba(255, 192, 203, 0.3)',
            color: '#8B5A5A',
            textShadow: '0 1px 2px rgba(255, 255, 255, 0.8)',
            boxShadow: '0 2px 8px rgba(255, 192, 203, 0.2)'
        }
    },
    {
        id: 'boho-earth',
        name: 'Boho Earth',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #F5E6D3 0%, #E8D5B7 50%, #F5E6D3 100%)',
            backgroundSize: '300% 300%',
            animation: 'gradientShift 14s ease-in-out infinite',
            border: '1px solid rgba(139, 90, 90, 0.2)',
            color: '#8B5A5A',
            textShadow: '0 1px 1px rgba(255, 255, 255, 0.6)'
        }
    },
    {
        id: 'minimal-sage',
        name: 'Minimal Sage',
        preview: 'Button',
        styles: {
            background: '#F0F4F0',
            color: '#5A6B5D',
            border: '1px solid rgba(90, 107, 93, 0.3)',
            textShadow: 'none',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
        }
    },
    {
        id: 'feminine-glow',
        name: 'Feminine Glow',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #FFF0F5 0%, #FFB6C1 50%, #FFF0F5 100%)',
            backgroundSize: '300% 300%',
            animation: 'gradientShift 16s ease-in-out infinite',
            border: 'none',
            color: '#8B4B61',
            textShadow: '0 1px 2px rgba(255, 255, 255, 0.9)',
            boxShadow: '0 3px 10px rgba(255, 182, 193, 0.3)'
        }
    },
    {
        id: 'cream-dream',
        name: 'Cream Dream',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #FFFDD0 0%, #F5F5DC 30%, #FDF5E6 60%, #FFFDD0 100%)',
            backgroundSize: '320% 320%',
            animation: 'gradientShift 18s ease-in-out infinite',
            border: '1px solid rgba(139, 90, 43, 0.1)',
            color: '#8B7355',
            textShadow: '0 1px 1px rgba(255, 255, 255, 0.7)'
        }
    },
    {
        id: 'dusty-rose',
        name: 'Dusty Rose',
        preview: 'Button',
        styles: {
            background: 'linear-gradient(45deg, #D4AFDF 0%, #C8A8D8 50%, #D4AFDF 100%)',
            backgroundSize: '300% 300%',
            animation: 'gradientShift 13s ease-in-out infinite',
            border: 'none',
            color: '#6B4C6B',
            textShadow: '0 1px 2px rgba(255, 255, 255, 0.6)',
            boxShadow: '0 2px 6px rgba(212, 175, 223, 0.3)'
        }
    }
];

function ButtonEffectsSelector({ 
    fieldName, 
    currentEffect, 
    onChange,
    containerRef
}) {
    const [isOpen, setIsOpen] = useState(false);
    
    const handleEffectSelect = (effectId) => {
        onChange({ target: { name: fieldName, value: effectId } });
        // Popup bleibt offen für weitere Auswahl
    };

    return (
        <div className="button-effects-selector-container">
            
            {/* Effects Trigger Button */}
            <button 
                type="button"
                className="button-effects-trigger"
                onClick={() => setIsOpen(!isOpen)}
                title="Button Effects"
            >
                <span className="button-effects-icon">✨</span>
            </button>

            {/* Effects Dropdown */}
            {isOpen && (
                <div className="button-effects-dropdown">
                    <div className="button-effects-header">
                        <h4>Button Effects</h4>
                        <span className="button-effects-subtitle">Click to apply</span>
                    </div>
                    
                    <div className="button-effects-grid">
                        {buttonEffects.map(effect => (
                            <div 
                                key={effect.id} 
                                className={`button-effects-option ${currentEffect === effect.id ? 'selected' : ''}`}
                                onClick={() => handleEffectSelect(effect.id)}
                            >
                                <div 
                                    className="button-effects-preview"
                                    style={effect.styles}
                                >
                                    {effect.preview}
                                </div>
                                <span className="button-effects-name">{effect.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Overlay zum Schließen */}
            {isOpen && (
                <div 
                    className="button-effects-overlay"
                    onClick={() => setIsOpen(false)}
                />
            )}
        </div>
    );
}

export default ButtonEffectsSelector;
